/**
 * Exploration load-trigger gate (X1d; mirrors src/editor/gate.ts). PURE predicate — the ONLY
 * exploration-related code mount may import eagerly. The world's `requires` doubles as the load
 * trigger (design-gameArch §6.1): a world that requires ANY exploration registry class pulls the
 * lazy vertical via `await import('../exploration/loader')`; every other world never downloads
 * a byte of it. The class set is DERIVED from the exploration sub-table's keys (eager-safe:
 * schemas + meta + lazy thunks only — already in the main bundle via ENTITY_REGISTRY's spread),
 * so new vertical classes arm the trigger with zero edits here.
 */
import { EXPLORATION_ENTITIES } from '../entities/exploration/table';

export function explorationRequired(requires: readonly string[]): boolean {
  return requires.some((name) => name in EXPLORATION_ENTITIES);
}
